import React from 'react';
import '../styles/Footer.css';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  TITLE,
  HOME,
  FOUNDERS,
  PARTNER,
  ABOUT,
  CONTACT,
  CONTACT_US,
  ADDRESS_1,
  ADDRESS_2,
  ADDRESS_3,
} from '../data/navbar/menu';
import { FOOTER_TAGLINE, FOOTER_QUICK_LINKS, FOOTER_LEGAL } from '../data/i18n/footer';
import {
  OUR_BRANDS_LABEL,
  BRAND_NUKRISHI_NAME,
  BRAND_AMERICANBULLS_NAME,
} from '../data/i18n/brands';
import { NUKRISHI_URL, AMERICANBULLS_URL } from '../data/brandUrls';
import Logo from '../assets/images/new_fk_logo.png';
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons';
import {
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const quickLinks = [
  { title: HOME, link: '/#home' },
  { title: FOUNDERS, link: '/#team' },
  { title: PARTNER, link: '/#partner' },
  { title: ABOUT, link: '/about' },
  { title: CONTACT, link: '/#contact' },
];

const Footer = () => {
  const {t} = useTranslation();
  return(
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-col">
            <div className="footer-brand">
              <img src={Logo} alt={t(TITLE)} />
            </div>
            <p className="footer-tagline">{t(FOOTER_TAGLINE)}</p>
            <div className="social-row">
              <a className="social-link" rel="noreferrer" target="_blank" href="https://twitter.com/freshokartz">
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a className="social-link" rel="noreferrer" target="_blank" href="https://facebook.com/freshokartz">
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a className="social-link" rel="noreferrer" target="_blank" href="https://www.instagram.com/freshokartz/">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a className="social-link" rel="noreferrer" target="_blank" href="https://www.linkedin.com/company/freshokartz">
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h5>{t(FOOTER_QUICK_LINKS)}</h5>
            <ul>
              {quickLinks.map((item) => (
                <li key={item.link}>
                  <a href={item.link}>{t(item.title)}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h5>{t(OUR_BRANDS_LABEL)}</h5>
            <ul>
              <li>
                <a href={NUKRISHI_URL} target="_blank" rel="noopener noreferrer">
                  {t(BRAND_NUKRISHI_NAME)}
                </a>
              </li>
              <li>
                <a href={AMERICANBULLS_URL} target="_blank" rel="noopener noreferrer">
                  {t(BRAND_AMERICANBULLS_NAME)}
                </a>
              </li>
            </ul>
            <h5 className="footer-col-spacer">{t(FOOTER_LEGAL)}</h5>
            <ul>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms &amp; Conditions</Link></li>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
            </ul>
          </div>

          <div className="footer-col contact-col">
            <h5>{t(CONTACT_US)}</h5>
            <p>
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              {t(ADDRESS_1)} {t(ADDRESS_2)} {t(ADDRESS_3)}
            </p>
            <p>
              <FontAwesomeIcon icon={faPhone} />
              +91 9610776707
            </p>
            <p>
              <FontAwesomeIcon icon={faEnvelope} />
              info@freshokartz.com
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© Copyright Freshokartz. All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
